"use client";

import Bugsnag from "@bugsnag/js";
import type { BugsnagErrorBoundary } from "@bugsnag/plugin-react";
import React from "react";
import type { PortalUser } from "@/contexts/AuthContext";

function isStarted(): boolean {
  try {
    return Bugsnag.isStarted();
  } catch {
    return false;
  }
}

const PassthroughBoundary: BugsnagErrorBoundary = ({ children }) => {
  return React.createElement(React.Fragment, null, children);
};

export function getErrorBoundary(): BugsnagErrorBoundary {
  if (!isStarted()) {
    return PassthroughBoundary;
  }
  const plugin = Bugsnag.getPlugin("react");
  if (!plugin) {
    return PassthroughBoundary;
  }
  return plugin.createErrorBoundary(React);
}

export function setBugsnagUser(user: PortalUser | null): void {
  if (!isStarted()) {
    return;
  }
  if (!user) {
    Bugsnag.setUser();
    Bugsnag.clearMetadata("tenant");
    return;
  }
  Bugsnag.setUser(user.userId, user.email, user.displayName ?? undefined);
  Bugsnag.addMetadata("tenant", {
    partnerCodes: user?.grants?.map((g) => g.partnerCode),
    partnerRoles: user?.grants?.map((g) => ({
      partnerCode: g?.partnerCode,
      role: g?.partnerRole,
    })),
    internalRole: user?.internalRole,
  });
}
